import { render, staticRenderFns } from "./QuotesItem.vue?vue&type=template&id=ef542916&scoped=true&"
import script from "./QuotesItem.vue?vue&type=script&lang=js&"
export * from "./QuotesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef542916",
  null
  
)

export default component.exports